import { useCalculate } from "@/modules/dwelling/containers/DwellingEstimateContainer/Calculate/useCalculate.tsx";

import styles from "../DwellingEstimateTable/DwellingEstimateTable.module.scss";
// types
import { CostingCleaning, DwellingCostCleaningPlansResponse } from "../types";
// components
import useDwellingCleaningEstimateTable from "./useDwellingCleaningEstimateTable.tsx";

export default function DwellingCleaningEstimateTable({
  name,
  cleaningPlans,
  cleaningData,
}: {
  cleaningData: CostingCleaning[];
  cleaningPlans: DwellingCostCleaningPlansResponse;
  name: string;
}) {
  const { cleaningTable } = useDwellingCleaningEstimateTable(
    cleaningData,
    cleaningPlans,
    name
  );
  const { costingCalculate, handleCountRepair } = useCalculate();

  return (
    <div className={styles.tablesContainer}>
      <h2 className={styles.title}>Nettoyage du logement</h2>
      <div className={styles.tablesContent}>
        <div className={styles.table}>
          <div className={styles.tableSection}>
            <div className={styles.tableTitle}>Sortie</div>
            <table>
              <thead>
                <tr>
                  {cleaningTable.map((column, index) => (
                    <th
                      key={index}
                      style={{
                        textAlign: "center",
                        ...column.style,
                      }}
                    >
                      {column.header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {cleaningData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {cleaningTable.map((column, columnIndex) => (
                      <td key={columnIndex} style={column.style}>
                        {column.body(row)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* total */}
      <div className={styles.totalSection}>
        <div className={styles.totalInfoLine}>
          Total des nettoyages :
          <strong> {handleCountRepair(name)} forfaits</strong>
        </div>
        <div className={styles.totalInfoLine}>
          Montant HT :{" "}
          <strong>
            {costingCalculate.elements[name].total.preTaxPrice.toFixed(2)} €
          </strong>
        </div>
        <div className={styles.totalInfoLine}>
          TVA :{" "}
          <strong>
            {costingCalculate.elements[name].total.taxAmount.toFixed(2)} €
          </strong>
        </div>
        <div className={styles.totalInfoLine}>
          Montant TTC :{" "}
          <strong>
            {costingCalculate.elements[name].total.total.toFixed(2)} €
          </strong>
        </div>
      </div>
    </div>
  );
}
